import { render, staticRenderFns } from "./Trems.vue?vue&type=template&id=7999a5c6&scoped=true&"
import script from "./Trems.vue?vue&type=script&lang=js&"
export * from "./Trems.vue?vue&type=script&lang=js&"
import style0 from "./Trems.vue?vue&type=style&index=0&id=7999a5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7999a5c6",
  null
  
)

export default component.exports